/**
 * MLS-DOC-CLASS-001 — document classification vocabulary + badge.
 * Classification is METADATA on the file record (component / section / utility_type /
 * file_type=mail_away_response) — never inferred from filenames.
 */
import React from 'react';

export const MLS_SECTIONS = [
  { key: 'code_violations', label: 'Code Violations' },
  { key: 'open_permits', label: 'Building Permits' },
  { key: 'utility_accounts', label: 'Utility' },
  { key: 'trash', label: 'Trash' },
  { key: 'other', label: 'Other' },
];
export const UTILITY_TYPES = [
  { key: 'water', label: 'Water' }, { key: 'sewer', label: 'Sewer' }, { key: 'trash', label: 'Trash' }, { key: 'other', label: 'Other' },
];
// MLS panel service key → section key
export const SERVICE_TO_SECTION = { code_violations: 'code_violations', open_permits: 'open_permits', utility: 'utility_accounts' };

export const sectionLabel = (key) => MLS_SECTIONS.find((s) => s.key === key)?.label || key || '';

export const classificationLabel = (file) => {
  if ((file?.component || '') !== 'mls') return 'Tax';
  const parts = ['MLS'];
  if (file.section) {
    parts.push(sectionLabel(file.section));
    if (file.section === 'utility_accounts' && file.utility_type) parts.push(UTILITY_TYPES.find((u) => u.key === file.utility_type)?.label || file.utility_type);
  }
  if (file.file_type === 'mail_away_response') parts.push('Mail-Away Response');
  return parts.join(' · ');
};

export const isMlsFile = (file) => (file?.component || '') === 'mls';

export const ClassificationBadge = ({ file, className = '', testId }) => {
  const mls = isMlsFile(file);
  const label = classificationLabel(file);
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10.5px] font-semibold whitespace-nowrap ${
        mls ? 'bg-indigo-50 text-indigo-700 border-indigo-200' : 'bg-amber-50 text-amber-800 border-amber-200'} ${className}`}
      title={mls && !file.section ? 'MLS document without a section — use Change classification to set one' : label}
      data-testid={testId || `file-class-badge-${file?.id}`}
    >
      {label}{mls && !file.section ? ' · Unsectioned' : ''}
    </span>
  );
};
